function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "chart-growth"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.4 0C0.1792 0 0 0.2016 0 0.45L0 8.55C0 8.7984 0.1792 9 0.4 9L3.6 9C3.8208 9 4 8.7984 4 8.55L4 0.45C4 0.2016 3.8208 0 3.6 0L0.4 0Z",
  transform: "translate(0 11)",
  id: "Path",
  fill: "#9FABE8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.36051 0.154954C6.18559 -0.0516515 5.81451 -0.0516515 5.63959 0.154954L0.101189 6.67935C-0.00957901 6.80984 -0.0312711 6.98861 0.0453435 7.13954C0.12242 7.29047 0.284418 7.38616 0.461647 7.38616L3.69238 7.38616L3.69238 19.565C3.69238 19.8051 3.89915 20 4.15392 20L7.84619 20C8.10095 20 8.30772 19.8051 8.30772 19.565L8.30772 7.38616L11.5385 7.38616C11.7157 7.38616 11.8777 7.29047 11.9543 7.13954C12.0314 6.98904 12.0097 6.80984 11.8989 6.67935L6.36051 0.154954Z",
  transform: "translate(4 0)",
  id: "Path",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}));

var SvgChartGrowth = function SvgChartGrowth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartGrowth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-growth.1a0fc183.svg";
export { ForwardRef as ReactComponent };